module.exports = __webpack_public_path__ + "img/markerYellow.97f9d0dd.svg";